<template>
  <div>
    <Header class="mb-5" />
    <v-main>
      <v-container fluid fill-height pa-0>
        <v-layout justify-center align-center>
          <v-flex>
            <router-view></router-view>
          </v-flex>
        </v-layout>
        <snack-bar
          :text="snackbar.text"
          :timeout="snackbar.timeout"
          :show="snackbar.show"
          :isTarget="snackbar.target === 'dashboard'"
        />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    Header: () => import('@/components/admin/shared/Header')
  },
  computed: {
    ...mapGetters(['snackbar'])
  }
}
</script>
